var React = require('react');

function AngleUpIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12,6c0.53,0,1.04,0.21,1.42,0.58l7.99,7.99c0.78,0.78,0.78,2.05,0,2.84c-0.78,0.78-2.05,0.78-2.84,0L12,10.82l-6.57,6.59c-0.78,0.78-2.05,0.78-2.84,0c-0.78-0.78-0.78-2.05,0-2.84l0,0l7.99-7.99C10.96,6.21,11.47,6,12,6z"}));
}

AngleUpIcon.defaultProps = {"data-dmid":"dm-angle-up","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = AngleUpIcon;

AngleUpIcon.default = AngleUpIcon;
